/* import __COLOCATED_TEMPLATE__ from './date-calendar-therapyfinder-embed.hbs'; */
import { classNames } from '@ember-decorators/component';
import RequestDateDateCalendar from './date-calendar';
import styles from './date-calendar-therapyfinder-embed.module.scss';

@classNames('date-calendar-therapyfinder-embed', styles.component)
export default class RequestDateDateCalendarTherapyfinderEmbed extends RequestDateDateCalendar {
  styles = styles;
}
